import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import {withStyles} from "@material-ui/core";

const InfoToolTip = withStyles((theme) => ({
    tooltip: {
        color: "#fff",
        maxWidth: 220,
        fontSize: '12px',
        fontWeight: "600",
        textAlign: 'center',
    },
}))(Tooltip);

export default function Info(props) {
    return (
        <InfoToolTip
            title={<div>{props.value}</div>}
            placement={props.placement}
        >
            {props.children}
        </InfoToolTip>
    );
}
